import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "The inspection",
    body: "Every detail begins with a slow, deliberate walkthrough. We read the surface — the grime you see and the grime you don't — and build a plan tailored to your vehicle or home.",
  },
  {
    n: "02",
    title: "The process",
    body: "Steam, extraction, hand-work. No shortcuts, no rushed rinses. We treat leather, fabric and every crevice with products chosen for their surface, not their price.",
  },
  {
    n: "03",
    title: "The finish",
    body: "Protected, conditioned and restored. What leaves our care looks and feels new again — a finish so complete it changes how you feel behind the wheel or through the front door.",
  },
];

export default function Manifesto() {
  return (
    <section id="process" className="py-24 lg:py-32 bg-secondary/40 border-y border-border" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-20">
          <p className="text-xs tracking-[0.3em] uppercase text-primary mb-4">The Platinum Standard</p>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none text-foreground">
            A ritual, not<br /> a rush job.
          </h2>
        </div>

        <div className="border-t border-border">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 py-12 border-b border-border group"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="lg:col-span-2">
                <span className="font-serif text-5xl lg:text-6xl text-primary/60 group-hover:text-primary transition-colors duration-500">{c.n}</span>
              </div>
              <div className="lg:col-span-4">
                <h3 className="font-serif text-3xl lg:text-4xl text-foreground">{c.title}</h3>
              </div>
              <div className="lg:col-span-6">
                <p className="text-muted-foreground font-light text-lg leading-relaxed">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
